// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1-zjz","fileBtn":"File_fileBtn__3CF8C","closeBtn":"File_closeBtn__SD1Bw","fileSelected":"File_fileSelected__1ymfa","disabled":"File_disabled__2FL6E"};